import React from "react";
import { Icon } from "@qgiv/core-react";
import "./ActivateAccountBadge.scss";

const ActivateAccountBadge = () => (
    <div className="activate-account-badge">
        <Icon
            className="activate-account-badge__icon"
            glyph="exclamation-circle-solid"
            type="FontAwesome"
        />
        <small>
            <strong>Activate Your Account</strong>
        </small>
    </div>
);

export default ActivateAccountBadge;
